import { SvgRelationshipTwoA, SvgRelationshipTwoAOneTwo, SvgRelationshipTwoB } from "components/Images/relationships";

const relationshipsTwo = [
     
      {
        id: 'relationships-2a',
        type: 'question',
        text: '<p>Rani begins to tell them how they met Amari. <br />They started out as friends, but after a couple of surfing lessons they realised that they were attracted to each other. From that point Rani and Amari were inseparable, hanging out all day, every day even after their surfing lessons ended. In fact, this is the first time they haven&rsquo;t spent the day together since they started dating.</p><p>Ky says &ldquo;I&rsquo;m glad we can finally get together. It feels like forever.</p><p>Rani agrees and says that Amari wasn&rsquo;t all that happy about it. Rani almost texted to cancel. Sam asks, &ldquo;Why? Didn&rsquo;t you want to come?&rdquo;</p><p>Rani responds:</p>',
        backgroundImage: SvgRelationshipTwoA,
        options: [
          {
            id: 'relationships-2a-option-1',
            text: '“Amari wanted to go the movies. They really hate it when we can’t see each other. Amari really cares about me and thinks we should be together all the time. I finally convinced them, but they were really upset about it. “',
            icon: '😔',
            iconBackground: '#faf4bb',
            nextStepId: 'relationships-2a-learnmore'
          },
          {
            id: 'relationships-2a-option-2',
            text: '“I don’t know. Every time I try to do something on my own, Amari gets upset. My mum and I were supposed to take a day trip to visit my sister and Amari got really mad. I was so anxious, I ended up making up some excuse not to go.”',
            icon: '😢',
            iconBackground:'#faf4bb',
            nextStepId: 'relationships-2b-learnmore',
  
          }
        ]
      },
      {
        id: 'relationships-2a-learnmore',
        type: 'learnmore',
        text: '<p>Even though intimate relationships can be very special, a healthy relationship shouldn&rsquo;t get in the way of your other relationships with friends and family. If Rani finds that they don&rsquo;t have time for other relationships, they might need to think about how to balance their time between their different relationships in a better, more healthy way. Communication is a key part of this.</p>',
        scrollText: "<span>Scroll down</span> for more.",
        backgroundImage:SvgRelationshipTwoA,
        learnmore: {
          title: "More about relationships 🤔",
          content: '<p>A lot of misunderstandings can occur in relationships from lack of communication, especially in the beginning of a new relationship when you&rsquo;re still getting to know each other. <br />In a respectful relationship you should be able to discuss how you feel about things and not feel judged by your partner. It can be difficult at first, but the more you talk openly the easier it will be for you to work out solutions quickly and to trust and support one another.</p><p>Visit <a href="https://bodytalk.org.au/relationships/" target="_blank">Body Talk</a> for more information on relationships.</p>'
        },
        nextStepId: 'relationships-2a-1-2',
      },

      {
        id: 'relationships-2a-1-2',
        type: 'question',
        text: '<p>Sam says, &ldquo;I get wanting to be together all the time!<br />But you should be able to spend time with us too.<br />You should really talk about it with them.&rdquo;<br />Rani agrees and asks, &ldquo;what should I say?&rdquo;&nbsp;</p><p>Alex responds:</p>',
        backgroundImage:  SvgRelationshipTwoAOneTwo ,
        options: [
          {
            id: 'relationships-2a-1-2-option-1',
            text: '“You could say ‘I love spending time with you. Our relationship is important to me but spending time with my friends is important too.’”',
            icon: '😗',
            iconBackground: '#faf4bb',
            nextStepId: 'relationships-2a-1-2-learnmore'
          },
          {
            id: 'relationships-2a-1-2-option-2',
            text: '“You could say ‘it’s important to me that we are able to talk things through together and make compromises. I need time to spend with friends. Let’s go see a movie tomorrow.’”',
            icon: '😯',
            iconBackground:'#faf4bb',
            nextStepId: 'relationships-2a-1-2-learnmore',
    
          }
        ]
      },

      {
        id: 'relationships-2a-1-2-learnmore',
        type: 'learnmore',
        text: '<p>Rani knows that communication is important but isn&rsquo;t sure how to talk about something they might not agree on. Even in a respectful relationship you will come across disagreements and arguments. It can be difficult at first, but the more you talk openly the easier it will be for you to work out solutions quickly and to trust and support one another.</p>',
        scrollText: "<span>Scroll down</span> for more.",
        backgroundImage: SvgRelationshipTwoAOneTwo,
        learnmore: {
          title: "More about relationships 🤔",
          content: '<p>Some ways differences can be managed respectfully include:</p><p>- Expressing feelings calmly and in a non-blaming way<br />- Understanding that it is ok to have differences, and to have different opinions<br />- Listening and understanding each other&rsquo;s point of view<br />- Being open to learning about new things and about each other&rsquo;s values<br />- Communicating wants and needs clearly<br />- Being willing to resolve disagreements; to negotiate and come to a compromise</p><p>Learn more at <a href="https://bodytalk.org.au/relationships/respectful-relationships/" target="_blank">Body Talk</a>.</p>'
        },
        nextStepId: null,
      },

      {
        id: 'relationships-2b-learnmore',
        type: 'learnmore',
        text: '<p>Amari is pressuring Rani to spend all their time with them. Even though intimate relationships can be very special, a healthy relationship shouldn&rsquo;t get in the way of your other relationships with friends and family. This is a sign of an unhealthy relationship.</p>',
        scrollText: "<span>Scroll down</span> for more.",
        backgroundImage: SvgRelationshipTwoA,
        learnmore: {
          title: "More about relationships 🤔",
          content: '<p>You may find yourself in a relationship with someone who says they care for you but they actually make you feel anxious, afraid or upset. This behaviour can be harmful to your emotional and physical health and can often get worse the longer you stay in the relationship.</p><p>Being able to identify the warning signs of an unhealthy relationship can help you to keep safe. This information can also be helpful if you have a friend experiencing an unhealthy relationship.</p><p>Visit <a href="https://bodytalk.org.au/relationships/feeling-safe/" target="_blank">Body Talk</a> for more information.</p>'
        },
        nextStepId: 'relationships-2b-1-2',
      },
      {
        id: 'relationships-2b-1-2',
        type: 'question',
        text: '<p>Ky and Alex look at each other with concern. Alex says: &ldquo;Rani, I&rsquo;m worried. That&rsquo;s one of those BIG RED FLAGS they talk about. Is this why you haven&rsquo;t been able to get together with me all summer?&rdquo;&nbsp;</p>',
        backgroundImage:  SvgRelationshipTwoB,
        options: [
          {
            id: 'relationships-2b-1-2-option-1',
            text: 'Rani says “Yes. I’ve tried to talk to Amari about it but they insist that if I loved them I’d want to spend all my time with them. They’re jealous of anyone I want to spend time with.”',
            icon: '😰',
            iconBackground: '#faf4bb',
            nextStepId: 'relationships-2b-1-2-learnmore'
          },
          {
            id: 'relationships-2b-1-2-option-2',
            text: 'Rani nods and looks at their phone anxiously. “This is the third message Amari has sent since I’ve arrived. I’m not sure how long I can stay, they want me come over.”',
            icon: '😧',
            iconBackground:'#faf4bb',
            nextStepId: 'relationships-2b-1-2-learnmore',
    
          }
        ]
      },

      {
        id: 'relationships-2b-1-2-learnmore',
        type: 'learnmore',
        text: "<p>Amari is pressuring Rani to spend all their time with them. They are trying to control them, checking up on them constantly and preventing them from seeing friends a family. This behaviour is unhealthy, and Rani&rsquo;s friends are concerned.</p><p>Many people assume that unhealthy behaviour in a relationship would be obvious to the people in the relationship. It can be hard to know what to do if your friend is in a harmful relationship.</p>",
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgRelationshipTwoB,
        learnmore: {
          title: "More about relationships 🤔",
          content: '<p>We all have a right to feel safe and respected in our relationships. It&rsquo;s important to remember that you have a choice to be in any relationship, and the right to leave. Your happiness and safety comes first and staying with someone because you&rsquo;re afraid to be alone, or you&rsquo;re worried about the possible consequences of leaving them, is never a good reason to be with someone.&nbsp;<br />If you, or someone you know, are experiencing unhealthy behaviour or abuse there are people who can help you.</p><p>Visit <a href="https://bodytalk.org.au/relationships/feeling-safe/" target="_blank">Body Talk</a> for more information.</p>'
        },
        nextStepId: null,
      },

]


export default relationshipsTwo